initializeFindingCards();

function initializeFindingCards() {
  const findingCards = document.querySelectorAll('.finding-card');

  findingCards.forEach((card) => {
    const findingCardId = card.id;

    const sidePanel = document.getElementById(`finding-side-panel-${findingCardId}`);
    const close = sidePanel.querySelector('.finding-side-panel__close');

    if (sidePanel) {
      card.addEventListener('click', () => {
        sidePanel.showModal();
        sidePanel.classList.add('open');
        document.body.classList.add('modal-open');
      });

      close.addEventListener('click', (event) => {
        event.preventDefault();
        sidePanel.classList.remove('open');
        setTimeout(() => {
          sidePanel.close();
        }, 500);
      });

      sidePanel.addEventListener('close', () => {
        document.body.classList.remove('modal-open');
      });

      sidePanel.addEventListener('click', (event) => {
        if (event.target === sidePanel) {
          sidePanel.classList.remove('open');
          setTimeout(() => {
            sidePanel.close();
          }, 500);
        }
      });
    }
  });
}

export { initializeFindingCards };
